import type { ComponentPublicInstance } from 'vue';
import type { FormRules, FormInstance } from 'element-plus';

export type SettingsForm = {
  deposit: number | null;
  subsequentAmount?: number;
  withdrawal: number | null;
  preset1: number | null;
  preset2: number | null;
  preset3: number | null;
  preset4: number | null;
  preset5: number | null;
}

export type CurrencyFormValue = {
  customRef: CurrencyFormInstance | null;
  data: SettingsForm;
  switchers: Record<number, boolean>;
};

export const initSettingsFormSwitchers = {
  preset4: false,
  preset5: false,
} as const;

export const initSettingsForm: SettingsForm = {
  deposit: null,
  withdrawal: null,
  preset1: null,
  preset2: null,
  preset3: null,
  preset4: null,
  preset5: null,
} as const;

export const changeableFields = ['preset4', 'preset5'];

export type CurrencyFormInstance = ComponentPublicInstance<{
  currencyFormRef: FormInstance;
  model: SettingsForm;
  rules: FormRules<SettingsForm>;
  switchers: Record<string, boolean>;
}>;
